<template>
  <div>
    <b-row class="m-0 justify-content-center" v-if="restaurant">
      <transition name="fade" mode="out-in">
        <div style="width: 1600px; max-width: 100%; " v-show="!expanded">
          <div>
            <b-row class="m-0 justify-content-center" v-if="table">

              <b-col lg="4" class="p-0 pr-lg-3 d-none d-lg-flex w-100 h-100" v-if="!isMobile" style="max-height: 100vh; overflow-y: auto; position: sticky; top: 0px;">
                <div class="ml-lg-5 mt-4 mb-5 p-3 shadow bg-white rounded w-100 h-100" style="margin-top: 100px !important">
                  
                  <b-row class="m-0 justify-content-center">
                    <b-img-lazy :src="getImages(restaurant.img.image)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>  
                  </b-row>
                              
                  <b-row class="m-0 mb-2 justify-content-center">
                    <h4>Bestellung</h4>
                  </b-row>
                  <b-row class="m-0 mb-2 justify-content-center">
                    <h5>Tisch {{ table.number }}</h5>
                  </b-row>
                  <p class="text-center mt-3" v-show="cart.length == 0">Wähle leckere Gerichte aus der Karte und bestelle Dein Menü.</p>
                  
                  <div class="my-2" v-for="(item, index) in cart" :key="item.index">
                    <cart-item :cartItem="item" :cart="cart" :index="index"></cart-item>
                  </div>
                  
                  <hr class="mt-2">
                  <b-row class="m-0 justify-content-between">
                    <p>Gesamtpreis:</p>
                    <p>{{ totalPrice }}€</p>
                  </b-row>

                  <div class="order-button shadow " :class="cart.length > 0 ? 'linear-warning hover' : 'bg-secondary forbidden' " @click="openOrderModal()">
                    <b-row class="m-0 justify-content-center mt-2 ">
                      <h4 v-show="cart.length == 0" class="mt-2 pt-1 text-center">Gerichte auswählen</h4>
                      <h4 v-show="cart.length > 0" class="mt-2 pt-1 text-center">{{ cart.length > 0 ? 'Bestellen' : ''}}</h4>
                    </b-row>
                  </div>
                </div>
              </b-col>

              <b-col cols="12" lg="8" class="p-0 h-100">
                <div class="mt-lg-4 mr-lg-5 shadow rounded" style="margin-top: 100px !important">

                  <div class="p-3 mt-3 bg-white">
                    <b-row class="m-0 justify-content-center d-lg-none">
                    <b-img-lazy :src="getImages(restaurant.img.image)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>  
                    </b-row>
                    <h3 class="text-center my-2">{{ restaurant.title}}</h3>
                    <h5 class="text-center">{{ restaurant.description}}</h5>
                    <p class="text-center my-2">{{ restaurant.adress.street}}, {{ restaurant.adress.city}}</p>
                    <p class="text-center my-2" v-if="getOpeningTimes().first || getOpeningTimes().second"> <span> {{ getOpeningTimes().first }} </span> <span class="ml-3"> {{ getOpeningTimes().second }} </span></p>
                    <p class="text-center my-2" v-else>heute geschlossen</p>
                    <b-row class="m-0 justify-content-center">
                      <div @click="openRatingModal()" style="max-width: 400px">
                        <b-form-rating  readonly class="hover text-center" size="md" :no-border="true" variant="warning" v-model="getRating"></b-form-rating>
                      </div>
                      <p v-if="restaurant.ratings" class="m-0 mt-2">({{restaurant.ratings.length}})</p>
                    </b-row>
                    <h4 class="text-center mt-3 mb-0">Kategorien</h4>
                  </div>

                  <div style="position: sticky; top: 0; left: 0; right: 0; z-index: 3001 !important;" v-if="!isMobile">
                    <div style="height: 85px; z-index: 3002;" class="shadow linear-warning scroll-container-categories" v-dragscroll id="scroll-container-categories">
                      <div class="scroll-item" @click="scrollToCategory(category._id)" :id="'item-'+category._id" v-for="category in restaurant.categories.filter(category => restaurant.menus.find(menu => menu.category._id == category._id))" :key="category.index">
                      {{ category.title }}
                      </div>
                    </div>
                  </div>

                  <div style="position: sticky; top: 0; left: 0; right: 0; z-index: 3001 !important;" v-else>
                    <div style="height: 85px; z-index: 3002;" class="shadow linear-warning scroll-container-categories" id="scroll-container-categories">
                      <div class="scroll-item" @click="scrollToCategory(category._id)" :id="'item-'+category._id" v-for="category in restaurant.categories.filter(category => restaurant.menus.find(menu => menu.category._id == category._id))" :key="category.index">
                      {{ category.title }}
                      </div>
                    </div>
                  </div>

                  <div class="p-3 bg-white">
                    <h3 class="text-center my-2">Speisekarte</h3>
                    <div style="z-index: 1000 !important" class="pt-2">
                      <div v-for="(category) in restaurant.categories.filter(category => restaurant.menus.find(menu => menu.category._id == category._id))" :key="category._id" >
                        <h3 class="text-left ml-1 my-3" :id="category._id">{{ category.title }}</h3>
                        <h4 class="text-left ml-1 my-3" >{{ category.description }}</h4>
                        <div v-for="menuitem in restaurant.menus.filter(menu => menu.category._id == category._id)" :key="menuitem._id">
                          <menu-item @addToCart="addToCart" :menuItem="menuitem"></menu-item>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </b-col>

            </b-row>
          </div>
          
        </div>
      </transition>
    </b-row>
    
    <b-row class="m-0 justify-content-center" v-if="!restaurant && !loadingRestaurant">
      <div style="width: 1600px; max-width: 100%; margin-top: 100px !important" >
        <b-row class="m-0 justify-content-center">
          <b-col cols="12" lg="12" style="z-index: 1000 !important">
            <div class="mt-3 shadow bg-white rounded p-3">
              <b-row class="m-0 my-5 justify-content-center">
                <b-img-lazy :src="require(`@/assets/images/undraw_searching.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>  
              </b-row>
              <h3 class="text-center my-2 mb-5">Dieses Restaurant gibt es scheinbar nicht, oder es ist gerade offline...</h3>
            </div>
          </b-col>      
        </b-row>
      </div>
    </b-row>

    <div style="height: 60vh; max-height: 60vh; overflow-y: auto; z-index: 1000 !important" class="pt-2" v-if="loadingRestaurant">
      <loading-overlay :text="'lade Restaurant...'" />
    </div>
    
    <Footer class="my-5" style="margin-bottom: 100px !important"></Footer>

    <div v-if="cart">
      
      <b-modal id="infoModal" class="" no-close-on-backdrop size="md" v-model="orderModal" hide-footer hide-header v-if="restaurant && !isMobile" :key="order.dsgvo_accepted.length">
        <div class="bg-white" style="border-radius: 10px; transition: all .5s;" >
          <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
            <h4 class="ml-2 text-center text-dark" >Deine Bestellung</h4>
            <font-awesome-icon v-show="!(orderState.confirmation_required || orderState.verified === false && !orderState.enable_refresh)" @click="orderModal = false, $store.commit('inHouseOrderState', null)" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
          </b-row>
          <div class="p-3 rounded" v-if="!inHouseOrderState">
            
            <b-row class="m-0 mb-5 justify-content-center">
              <b-img-lazy class="mt-3" :src="require(`@/assets/images/undraw_shopping.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>              
            </b-row>

            <div class="my-3" v-for="(item) in cart" :key="item.index">

              <cart-item :cartItem="item" :cart="cart" :index="index" :checkOrder="true"></cart-item>

            </div>
            
            <hr class="m-2">
            
            <b-row class="m-0 justify-content-between w-100">
              <h3>Gesamtpreis:</h3>
              <h3>{{ totalPrice }}€</h3>
            </b-row>

            <div v-show="restaurant.enable_online_order"> 

              <div class="order-button shadow linear-warning hover"  @click="postInHouseOrder()">
                <b-row class="m-0 justify-content-center mt-2 ">
                  <h5 class="mt-2 pt-1 text-center">Im Restaurant bestellen</h5> 
                </b-row>
              </div>
      
            </div>
          </div>
          <div v-else>
            <div v-if="inHouseOrderState.status == 'success'" class="my-5 pb-5">
              <h3 class="text-center text-success">Bestellung erfolgreich</h3>
              <b-row class="m-0 justify-content-center mt-5">
                <b-button variant="success" @click="orderModal = false, $store.commit('inHouseOrderState', null)">fertig</b-button>
              </b-row>
            </div>
          </div>

        </div>
      </b-modal>
    </div>

    <b-modal id="infoModal" size="lg" v-model="signInModal" centered hide-footer hide-header no-close-on-backdrop v-if="restaurant && table">
   
      <div class="bg-white shadow p-3" style="border-radius: 10px; transition: all .5s;" >
        <h3 class="text-center">Willkommen bei {{ restaurant.title }}</h3>
        <h4 class="my-4 text-center">Ihr Tisch: Tisch {{ table.number }}</h4>
        <b-row class="m-0 justify-content-center">
          <div class="order-button shadow linear-warning hover" @click="checkIn()">
            <b-row class="m-0 justify-content-center mt-2 ">
              <h4 class="py-2 text-center">Einchecken</h4>
            </b-row>
          </div>
        </b-row>
      </div>
    </b-modal>

    <b-modal id="infoModal" size="md" v-model="ratingModal" hide-footer hide-header v-if="restaurant">
   
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;" v-if="restaurant.ratings">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark" >{{ restaurant.title }}</h4>
          <font-awesome-icon @click="ratingModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <b-row class="m-0 justify-content-center" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
        <p class="m-0">Bewertungen ({{restaurant.ratings.length}}):</p>
        </b-row>
        <b-row class="m-0 pb-1 justify-content-center" style="border-top-left-radius: 10px; border-top-right-radius: 10px;" v-show="!restaurant.ratings">
        aktuell noch keine Bewertungen vorhanden
        </b-row>
        <div class="m-3" v-for="rating in restaurant.ratings" :key="rating.index">
          <b-row class="m-0 mx-4 justify-content-between">
            <small>{{ rating.sender }}</small>
            <small v-if="rating.date">{{ rating.date | moment('DD.MM.YY HH:mm')}}</small>
          </b-row>
          <p class="m-0 ml-4 mt-2">{{ rating.text }}</p>
          
          <b-form-rating readonly class="hover mb-3 p-0 text-center" size="md" :no-border="true" variant="warning" v-model="rating.rating"></b-form-rating>           
          <hr class="mx-3">
        </div>
            
      </div>
    </b-modal>

    <!-- mobile order -->

    <div v-if="restaurant && isMobile" class="d-block d-lg-none shadow bg-white" style="z-index: 3001; position: fixed; bottom: 0px; left: 0; right: 0; transition: all 0.3s ease-in-out; height: 100vh; overflow: auto" :style="expanded ? 'height: 100%' : 'height: 70px'" >
      
      <b-row class="m-0 py-3 justify-content-between" style="transition: all .5s; height: height: 85px " :class="animateCart ? 'bg-success' : 'bg-warning'" @click="expanded = !expanded">
        <div style="position: relative">
          <font-awesome-icon class="ml-3 h1 hover text-dark" :icon="['fas', 'shopping-cart']"/>
          <h2 class="m-0 p-0" style="position: absolute; top: -15px; left: 40px"><b-badge pill variant="info">{{ getCartItems }}</b-badge></h2>
        </div>
        <font-awesome-icon v-show="expanded" class="ml-3 h3 mt-2 hover text-dark" :icon="['fas', 'chevron-down']"/>
        <h3 class="mr-3 mt-1 text-dark">Warenkorb {{ totalPrice }} €</h3>
      </b-row>

      <!-- Before Order -->
      <div class="bg-white" style="transition: all .5s;" v-show="!orderModalMobile && expanded">
        <div class="ml-lg-5 p-3 " v-if="!inHouseOrderState">
          <b-row class="m-0 justify-content-center">
            <h1>Tisch {{ table.number }}</h1>
          </b-row>
          <p class="text-center mt-2" v-show="cart.length == 0">Wähle leckere Gerichte aus der Karte und bestelle Dein Menü.</p>
          
          <div class="bg-light p-2 rounded" style="max-height: 40vh; overflow-y: auto">
            <div class="my-3" v-for="(item, index) in cart" :key="item.index">
              <cart-item :cartItem="item" :cart="cart" :index="index"></cart-item>
            </div>
          </div>
          <hr class="m-2">
          <b-row class="m-0 justify-content-between">
            <h3>Gesamtpreis:</h3>
            <h3>{{ totalPrice }}€</h3>
          </b-row>

          <div> 

              <div class="order-button shadow hover" :class="cart.length > 0 ? 'linear-warning hover' : 'bg-secondary forbidden' "  @click="postInHouseOrder()">
                <b-row class="m-0 justify-content-center mt-2 ">
                  <h5 class="mt-2 pt-1 text-center">Im Restaurant bestellen</h5> 
                </b-row>
              </div>
      
            </div>
        </div>
        <div v-else>
            <div v-if="inHouseOrderState.status == 'success'" class="my-5 pb-5">
              <h3 class="text-center text-success">Bestellung erfolgreich</h3>
              <b-row class="m-0 justify-content-center mt-5">
                <b-button variant="success" @click="orderModal = false, $store.commit('inHouseOrderState', null), expanded = false">fertig</b-button>
              </b-row>
            </div>
          </div>
      </div>

    </div>

  </div>
</template>

<script>

import Footer from '@/components/Footer'
import LoadingOverlay from '../shared/animations/loadingOverlay.vue'
import MenuItem from './components/MenuItem'
import CartItem from './components/CartItem'

export default {
  name: 'InHouse',
  components: {
    LoadingOverlay,
    Footer,
    MenuItem,
    CartItem,
  },
  beforeUpdate(){
   
  },
  data: () => {
    return {
      signInModal: false,
      delivery: null,
      animateCart: false,
      isMobile: null,
      orderModalMobile: false,
      expanded: false,
      form: {
        email: '',
        password: ''
      },
      now: null,
      extrasItem: null,
      extrasModal: false,
      timeString: null,
      customDate: null,
      preNumber: '+49',
      days: [],
      timeModal: false,
      selectedTime: null,
      selectedDate: null,
      interval: null,
      timestamp: "",
      preTime: 0,
      dummy: null,
      timer: 60,
      securityCode: '',
      tabIndex: 0,
      orderActive: false,
      order: {dsgvo_accepted: false, phone:''},
      ratingModal: false,
      cartModal: false,
      orderModal: false,
      activeMenu: {},
      infoModal: false,
      cart: [],
      showDetail: false,
      loginModal: false,
      registerActive: false,
      distance: 13,
      rating: 0
      
    }
  },
  computed: {
    table(){
      return this.$store.getters.table
    },
    appversion(){
      return this.$store.getters.appversion
    },
    storedOrder(){
      return this.$store.getters.storedOrder
    },
    getCartItems(){
      var amount = 0
      if(this.cart){
        this.cart.forEach(element => {
          amount += element.amount
        })
      }
      return amount
    },
    warning(){
      if(this.slots && this.selectedTime){
        if(this.selectedTime < this.slots[0].date) {
          return true
        }
      }
      if(this.selectedTime == 'over') return true
      return false
    },
    slots(){
      return this.$store.getters.slots
    },
    updating(){
      return this.$store.getters.updating
    },
    orderState(){
      return this.$store.getters.orderState
    },
    inHouseOrderState(){
      return this.$store.getters.inHouseOrderState
    },
    loggedIn(){
      return this.$store.getters.loggedIn
    },
    getRating(){
      if(!this.restaurant.ratings) return 0.0
      var rating = 0.0
      this.restaurant.ratings.forEach(el => {
        rating += el.rating
      })

      return rating / this.restaurant.ratings.length
    },
    globalCart(){
      return this.$store.getters.globalCart
    },
    darkMode(){
      return this.$store.getters.darkMode
    },
    restaurant(){
      var restaurant = this.$store.getters.restaurant
      if(restaurant){
        restaurant.menus.sort( this.compareCatecories );
      }
      return restaurant
    },
    loadingRestaurant(){
      return this.$store.getters.loadingRestaurant
    },
    totalPrice(){
      var total = 0.00
      if(this.cart.length == 0) return total

      this.cart.forEach(item => {
        total += item.price * item.amount
        if(item.extras){
          item.extras.forEach(extra => {
            if(extra.choosen){
              total += extra.price * item.amount
              if(item.variants.length > 0){
                item.variants.forEach(variant => {
                  if(variant.choosen){
                    total += variant.choosen.extra_price * item.amount
                  }
                })
              }
            }
          })
          if(item.variants){
            if(item.variants.find(variant => variant.choosen)){
              item.variants.filter(variant => variant.choosen).forEach(element => {
                total += element.choosen.price * item.amount
              })
            }
          }
          
        }
      })

      return total.toFixed(2)
    }
  },
  watch: {
    inHouseOrderState(){
      if(this.inHouseOrderState){
        if(this.inHouseOrderState.status == 'success'){
          this.cart = []
          localStorage.setItem('cart', null)
        }
      }
    },
    table(){
      if(this.table){
        if(!this.table.blocked){
          this.signInModal = true
        }
      }
    },
    expanded(){
      if(!this.expanded){
        this.resetOrder()
        this.orderModalMobile = false
        this.orderActive = false
      }
    },
    restaurant(){
      if(!this.restaurant) return

      const descEl = document.querySelector('head meta[name="description"]');
      const titleEl = document.querySelector('head title');

      descEl.setAttribute('content', this.restaurant.description);
      titleEl.textContent = 'ᐅ eatDorado | ' + this.restaurant.title + ' - ' + this.restaurant.adress.city;

      this.dummy = JSON.parse(localStorage.getItem('cart'))

      if(this.globalCart.length == 0 && this.dummy){
        this.$store.commit('globalCart', this.dummy)
        if(this.dummy.find(el => el._id == this.restaurant._id)){

            this.cart = this.dummy.find(el => el._id == this.restaurant._id).cart
            this.cart.forEach((item, index) => {
              if(!this.restaurant.menus.find(el => el._id == item._id)){
                this.cart.splice(index, 1)
              }
            })
        }
      }else{
        if(this.globalCart.find(el => el._id == this.restaurant._id)){
            this.cart = this.globalCart.find(el => el._id == this.restaurant._id).cart
            this.cart.forEach((item, index) => {
              if(!this.restaurant.menus.find(el => el._id == item._id)){
                this.cart.splice(index, 1)
              }
            })
        }
      }
      this.$store.dispatch('checkSlots', {company: this.restaurant._id, date: this.timeString})

    },
    selectedDate(){
      if(this.selectedDate){
        this.$store.dispatch('checkSlots', {company: this.restaurant._id, date: this.selectedDate})
        this.preTime = 0
        this.selectedTime = null
        this.timeString = this.selectedDate
      }
    },
    orderModal(){
      if(!this.orderModal){
        this.orderActive = false
        this.resetOrder()
      } 
    },
    order: {
      handler: function () {
        this.$store.commit('orderState', {})
      },
      deep: true
    },
    cart: {
      handler: function () {
        var index = 0
        var payload = {
          _id: this.restaurant._id,
          cart: this.cart
        }
        if(this.globalCart){
          if(this.globalCart.find(el => el._id == this.restaurant._id)){
            index = this.globalCart.findIndex(el => el._id == this.restaurant._id)
            this.globalCart.splice(index, 1)
            this.globalCart.push(payload)
          }else{
            this.globalCart.push(payload)
          }
        }
        
      },
      deep: true
    }
  },
  mounted(){
    this.$store.dispatch('getTable', {_id: this.$route.query.tableId})
    this.checkVersions();
    localStorage.setItem('cart', null)
    this.$nextTick(function() {
      
      window.addEventListener('resize', this.getWindowWidth);
      // document.getElementById('scroll-container').addEventListener('scroll', this.getScrollHeight)
      this.getWindowWidth()
    })

    this.getWindowWidth()
    var today = new Date()
    this.timeString =  today.getFullYear()+ '-' + ("0" + (today.getMonth()+1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2)
    
    if(this.restaurant){
      const descEl = document.querySelector('head meta[name="description"]');
      const titleEl = document.querySelector('head title');

      descEl.setAttribute('content', this.restaurant.description);
      titleEl.textContent = this.restaurant.title + ' ' + this.restaurant.adress.city;
      
      this.$store.dispatch('checkSlots', {company: this.restaurant._id, date: this.timeString})

    }
    
    this.getNow()
    this.interval = setInterval(this.getNow, 30000);
    this.$store.commit('orderState', {})
    this.$store.commit('restaurant', null)
    this.$store.dispatch('getRestaurant', {_id: this.$route.params.id})
    
    // if(this.restaurant){
    //   this.dummy = JSON.parse(localStorage.getItem('cart'))

    //   if(this.globalCart.length == 0 && this.dummy){
    //     this.$store.commit('globalCart', this.dummy)
    //   }

    //   if(this.globalCart.find(el => el._id == this.restaurant._id)){
    //       this.cart = this.globalCart.find(el => el._id == this.restaurant._id).cart
    //   }
    // }
    
  },
  beforeDestroy(){
    clearInterval(this.interval)
    clearInterval(this.resendTimer)
    window.removeEventListener('resize', this.getWindowWidth);
  },
  methods: {
    checkIn(){
      if(this.table.blocked) return
      this.$store.dispatch('blockTable', {blocked: true, _id: this.table._id})
      window.location.reload()
    },
    degreesToRadians(degrees) {
      return degrees * Math.PI / 180;
    },
    distanceInKmBetweenEarthCoordinates(lat1, lon1, lat2, lon2) {
      var earthRadiusKm = 6371;
    
      var dLat = this.degreesToRadians(lat2-lat1);
      var dLon = this.degreesToRadians(lon2-lon1);
    
      lat1 = this.degreesToRadians(lat1);
      lat2 = this.degreesToRadians(lat2);
    
      var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

      if(lat1 && lon1 && lat2 && lon2){
        return (earthRadiusKm * c).toFixed(2) ;
      }else{
        return null
      }
      
    },
    checkDeliveryTimes(){
      var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      var d = new Date();
      var dayName = days[d.getDay()];
      const openingTimes = this.restaurant.delivery_times[dayName]
      const today = new Date().getFullYear()+'-'+('0'+(new Date().getMonth()+1)).slice(-2)+'-'+('0'+new Date().getDate()).slice(-2)
      const dateStart_1 = new Date(today+'T'+openingTimes.start_1)
      const dateStart_2 = new Date(today+'T'+openingTimes.start_2)
      const dateEnd_1 = new Date(today+'T'+openingTimes.end_1)
      const dateEnd_2 = new Date(today+'T'+openingTimes.end_2)

      if(dateStart_1 < new Date() && dateEnd_1 > new Date()){
        return true
      }

      if(dateStart_2 < new Date() && dateEnd_2 > new Date()){
        return true
      }

      console.log(this.restaurant.delivery_times[dayName])
      return false
    },
    checkVersions() {
      this.$store.dispatch('getAppversion')
      if(this.appversion){
        if(this.appversion.web_version != process.env.VUE_APP_VERSION){
          window.location.reload()
        }
      }
    },
    getOpeningTimes(){
      var timeString = {}
      var date = new Date()
      var day = date.getDay()
      switch (day) {
        case 0:
          if(this.restaurant.opening_times.sunday.start_1 && this.restaurant.opening_times.sunday.end_1){
            timeString.first = this.restaurant.opening_times.sunday.start_1 + ' - ' + this.restaurant.opening_times.sunday.end_1
          }
          if(this.restaurant.opening_times.sunday.start_2 && this.restaurant.opening_times.sunday.end_2){
            timeString.second = this.restaurant.opening_times.sunday.start_2 + ' - ' + this.restaurant.opening_times.sunday.end_2
          }
          return timeString
        case 1:
          if(this.restaurant.opening_times.monday.start_1 && this.restaurant.opening_times.monday.end_1){
            timeString.first = this.restaurant.opening_times.monday.start_1 + ' - ' + this.restaurant.opening_times.monday.end_1
          }
          if(this.restaurant.opening_times.monday.start_2 && this.restaurant.opening_times.monday.end_2){
            timeString.second = this.restaurant.opening_times.monday.start_2 + ' - ' + this.restaurant.opening_times.monday.end_2
          }
          return timeString
        case 2:
          if(this.restaurant.opening_times.tuesday.start_1 && this.restaurant.opening_times.tuesday.end_1){
            timeString.first = this.restaurant.opening_times.tuesday.start_1 + ' - ' + this.restaurant.opening_times.tuesday.end_1
          }
          if(this.restaurant.opening_times.tuesday.start_2 && this.restaurant.opening_times.tuesday.end_2){
            timeString.second = this.restaurant.opening_times.tuesday.start_2 + ' - ' + this.restaurant.opening_times.tuesday.end_2
          }
          return timeString
        case 3:
          if(this.restaurant.opening_times.wednesday.start_1 && this.restaurant.opening_times.wednesday.end_1){
            timeString.first = this.restaurant.opening_times.wednesday.start_1 + ' - ' + this.restaurant.opening_times.wednesday.end_1
          }
          if(this.restaurant.opening_times.wednesday.start_2 && this.restaurant.opening_times.wednesday.end_2){
            timeString.second = this.restaurant.opening_times.wednesday.start_2 + ' - ' + this.restaurant.opening_times.wednesday.end_2
          }
          return timeString
        case 4:
          if(this.restaurant.opening_times.thursday.start_1 && this.restaurant.opening_times.thursday.end_1){
            timeString.first = this.restaurant.opening_times.thursday.start_1 + ' - ' + this.restaurant.opening_times.thursday.end_1
          }
          if(this.restaurant.opening_times.thursday.start_2 && this.restaurant.opening_times.thursday.end_2){
            timeString.second = this.restaurant.opening_times.thursday.start_2 + ' - ' + this.restaurant.opening_times.thursday.end_2
          }
          return timeString
        case 5:
          if(this.restaurant.opening_times.friday.start_1 && this.restaurant.opening_times.friday.end_1){
            timeString.first = this.restaurant.opening_times.friday.start_1 + ' - ' + this.restaurant.opening_times.friday.end_1
          }
          if(this.restaurant.opening_times.friday.start_2 && this.restaurant.opening_times.friday.end_2){
            timeString.second = this.restaurant.opening_times.friday.start_2 + ' - ' + this.restaurant.opening_times.friday.end_2
          }
          return timeString
        case 6:
          if(this.restaurant.opening_times.saturday.start_1 && this.restaurant.opening_times.saturday.end_1){
            timeString.first = this.restaurant.opening_times.saturday.start_1 + ' - ' + this.restaurant.opening_times.saturday.end_1
          }
          if(this.restaurant.opening_times.saturday.start_2 && this.restaurant.opening_times.saturday.end_2){
            timeString.second = this.restaurant.opening_times.saturday.start_2 + ' - ' + this.restaurant.opening_times.saturday.end_2
          }
          return timeString
        default:
          break;
      }
    },

    scrollToCategory(id){
      var categoryPos = document.getElementById(id).offsetTop;
      var itemPos = document.getElementById('item-'+id).offsetLeft;

      var myDiv = document.getElementById('scroll-container');
      var scrollContainerCategories = document.getElementById('scroll-container-categories');

      myDiv.scrollTo({top: categoryPos -100, behavior: 'smooth'});
      scrollContainerCategories.scrollTo({left: itemPos - 10 , behavior: 'smooth'});
    },

    submitLogin(){
      var payload = {
        email: this.form.email,
        password: this.form.password,
        noredirect: true
      }
      this.$store.dispatch('login', payload)
    },

    getWindowWidth() {
      this.isMobile = document.documentElement.clientWidth < 992 ? true : false
    },
    resetOrder(){
      if(this.timer > 0 && !this.orderState.enable_refresh) return
      this.$store.commit('orderState', {})
      this.orderActive = false
      this.securityCode = ''
    },
    getMoreVariant(){

      if(this.slots){
        if(this.slots.length == 1){
          if(this.preTime.time != this.slots[0].time || this.selectedDate) return 'dark'
        }
        if(this.slots.length == 2){
          if(this.preTime.time != this.slots[0].time && this.preTime.time != this.slots[1].time || this.selectedDate) return 'dark'
        }
        if(this.slots.length >= 3){
          if(this.preTime.time != this.slots[0].time && this.preTime.time != this.slots[1].time && this.preTime.time != this.slots[2].time || this.selectedDate) return 'dark'
        }
       
      }
      return 'outline-dark'
    },
    getExtrasPrice(menu){
      var price = menu.price
      menu.extras.forEach(element => {
        if(element.choosen){
          price += element.price
          if(menu.variants.length > 0){
            menu.variants.forEach(variant => {
              if(variant.choosen){
                price += variant.choosen.extra_price
              }
            })
          }
        }
      });
      if(menu.variants){
        if(menu.variants.find(variant => variant.choosen)){
          menu.variants.filter(variant => variant.choosen).forEach(element => {
            price += element.choosen.price
          })
        }
      }
      
       return price.toFixed(2)
    },
    getCategory(menu, index){
      if(!menu.category) return
      if(!this.restaurant.menus[index - 1])return this.restaurant.menus[index].category
      if(this.restaurant.menus[index].category.title != this.restaurant.menus[index - 1].category.title) return this.restaurant.menus[index].category
    },
    compareCatecories( a, b ) {
      if(a.category && b.category){
        var A = a.category.title
        var B = b.category.title
        if ( A < B ){
          return -1;
        }
        if ( A > B ){
          return 1;
        }
        return 0;
      }
    },
    openOrderModal(){
      if(!this.restaurant || this.cart.length == 0 ) return 
      this.orderModal = true
      this.cartModal = false
    },
    openOrderModalMobile(){
      if(!this.restaurant || !this.cart.length > 0) return 
      this.orderModalMobile = true
    },
    dateDisabled() {
        return false
    },
    getNextTime(minutes){
      var date = new Date(this.nextTimes.time1.date.getTime() + minutes*60000);
      var payload = {
        date: date,
        time: ("0" + (date.getHours())).slice(-2)+':'+("0" + (date.getMinutes())).slice(-2)
      }
      return payload
    },

    selectTime(index, time){
      this.preTime = index
      this.selectedTime = time.date
      this.timeModal = false
    },

    getNow: function() {
      const today = new Date();
      this.now = new Date();
      const time = ("0" + today.getHours()).slice(-2) +':'+ ("0" + today.getMinutes()).slice(-2)
      const dateTime = time;
      this.timestamp = dateTime;
      if(this.restaurant){
        this.$store.dispatch('checkSlots', {company: this.restaurant._id, date: this.timeString})
      }
    },

    resendCode(){
      if(this.timer > 0) return
      this.$store.dispatch('resendConfirmation', {_id: this.orderState.order._id})
      this.setTimer()
      clearInterval(this.resendTimer);
    },

    confirmOrder(){
      if(this.updating || !this.storedOrder) return
      const payload = {
        _id: this.storedOrder._id,
        change_route: true,
        data: {
          verification_number: this.securityCode
        }
      }

      var index = this.globalCart.findIndex(el => el._id == this.restaurant._id)
      this.globalCart.splice(index, 1)
      this.$store.dispatch('confirmOrder', payload)
    },
    setTimer(){
      this.timer = 120
      var vm = this
      this.resendTimer = setInterval(function(){
        if(vm.timer <= 0){
          clearInterval(vm.resendTimer);
        }
        vm.timer -= 1;
      }, 1000);
    },

    postInHouseOrder(){   
      if(this.cart.length == 0) return    
      var payload = {
        title: 'Bestellung',
        description: '',
        customer_email: this.order.email,
        customer_firstname: this.order.firstname,
        customer_lastname: this.order.lastname,
        company: this.restaurant._id,
        visitor_group: this.table.visitor_group,
        items: this.cart,
        created: new Date(),
        delivery_time: this.selectedTime,
        price: this.totalPrice,
      }

      console.log(payload)
      this.$store.dispatch('postInHouseOrder', payload)
    },

    openRatingModal(){
      if(!this.restaurant.ratings) return
      if(this.restaurant.ratings.length == 0) return 
      this.ratingModal = true
    },
    windowOpen(){
      window.open('href="' +this.restaurant.contact.phone + '", "_blank"')
    },
    getImages(img){
      return process.env.VUE_APP_API_BASEURL + '/' + img
    },
    login(){
      var payload = {
        email: this.form.email,
        password: this.form.password
      }
      this.$store.dispatch('login', payload)
    },
    addToCart(item){
      const menuItem = JSON.parse(JSON.stringify(item))
      var vm = this
      if(this.cart.find(el => {
        if(el._id == item._id){
           if(JSON.stringify(el.extras) == JSON.stringify(item.extras)) return true
        }
      })){
        this.cart.find(el => el._id == menuItem._id).amount += 1
      }else{
        menuItem.amount = 1
        this.cart.push(menuItem)
      }

      vm.animateCart = true
      setTimeout(function(){ 
        vm.animateCart = false
       }, 500);

    },
    addToCartExtras(item){
      this.extrasItem = item
      this.extrasModal = true
    },
    addItem(item){
      if(this.cart.find(el => el._id == item._id).amount >= 10) return
      this.cart.find(el => el._id == item._id).amount += 1
    },
    subItem(item, index){
      this.cart.find(el => el._id == item._id).amount -= 1
      if(this.cart.find(el => el._id == item._id).amount <= 0){
        this.cart.splice(index, 1)
      }
    },
    addExtra(item){
      if(!item.amount){
        item.amount = 1
      }
      item.amount += 1
    },
    subExtra(item){
      if(!item.amount){
        item.amount = 0
        return
      }

      item.amount -= 1
    }
  }
}
</script>
<style lang="scss">
  .b-calendar-grid-help {
    display: none !important;
  }

  .b-calendar-grid {
    border: none !important;
  }

  .scroll-container-categories {
    overflow: auto;
    white-space:nowrap;
    width: 100%;
    height: 100%;
    cursor : -webkit-grab;
    cursor : -moz-grab;
    cursor : -o-grab;
    cursor : grab;
  }
  .scroll-item {
    cursor: pointer;
    padding: 10px;
    margin-top: 20px;
    background-color: white;
    border-radius: 20px;
    display: inline-block;
    vertical-align:center;
    margin-right:10px;
    margin-left:10px;
    // white-space:normal;
  }

.scroll-container-categories:active {
  cursor : -webkit-grabbing;
  cursor : -moz-grabbing;
  cursor : -o-grabbing;
  cursor : grabbing;
}
</style>